import styled from "styled-components"

export const TerminalAddButtonContainer = styled.div`
  position: absolute;
  bottom: -5.4rem;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  pointer-events: none;
`

/** Solid filled style — terminal "+" is the primary action for appending a
 *  new child / parallel sibling to this node's output. Visually distinct
 *  from the subtle outlined mid-edge insert button. */
export const TerminalAddButtonCircle = styled.button<{ $highlighted?: boolean }>`
  pointer-events: all;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
  background: ${(p) =>
    p.$highlighted ? p.theme.colors.turquoiseDarker : p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  ${(p) => p.theme.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${(p) =>
    p.$highlighted
      ? "0 0 0 0.4rem rgba(57, 179, 155, 0.25), 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15)"
      : "0 0.15rem 0.4rem rgba(57, 179, 155, 0.35)"};
  transition: all 0.15s ease;
  padding: 0;
  /* Render the "+" via a pseudo-element so we control its box exactly —
   * many text fonts give the "+" glyph asymmetric bearings which makes a
   * raw "+" character sit slightly low/left inside a perfect circle. The
   * pseudo-element is a square with absolute font metrics, kept on the
   * pixel grid by translateZ(0). */
  font-size: 0;
  line-height: 0;

  &::before {
    content: "+";
    font-size: 1.7rem;
    line-height: 1;
    display: inline-block;
    transform: translate(0, -0.05rem) translateZ(0);
  }

  ${(p) =>
    p.$highlighted
      ? "transform: scale(1.25);"
      : "transform: scale(1);"}

  &:hover {
    background: ${(p) => p.theme.colors.turquoiseDarker};
    border-color: ${(p) => p.theme.colors.turquoiseDarker};
    box-shadow: 0 0.2rem 0.6rem rgba(57, 179, 155, 0.45);
    transform: scale(1.08);
  }
`
